function loadMore(imageSet,imageGallery,loaded,batchSize,btn){
    const nextBatch = imageSet.slice(loaded, loaded + batchSize);
    renderItems(nextBatch,imageGallery);
    loaded += nextBatch.length;

   

    if (loaded >= imageSet.length){
        btn.disabled = true;
        btn.textContent = "All loaded";
        btn.classList.add("hidden");
    }

    return loaded;
}

function renderItems (batch,imageGallery){
  
    const gallery = document.getElementById(imageGallery);
    const blockID = imageGallery.replace("image-gallery-","");

    //for i in batch, create a new image in the target div. 
        //if the target div has class "lighbox", add lightbox to the image

    for(const img of batch){
        //create gallery item
        const galleryItemDiv = document.createElement("div");
        galleryItemDiv.classList.add("gallery-item");
        galleryItemDiv.classList.add("gallery-item-"+blockID);
        galleryItemDiv.classList.add("animate-in-image")


        //create img
        const newImage = new Image();
        newImage.src = img.src;
        newImage.alt = img.alt;

        
        if (gallery.classList.contains("lightBox_enabled")){
            newImage.classList.add("lightImg");

            newImage.addEventListener('click', () => {
                lightboxImg.src = img.src;
                lightbox.classList.add('active');
                document.body.style.overflow = 'hidden'; // stop scrolling
            
            });

        }

        galleryItemDiv.appendChild(newImage);


        //add to gallery
        gallery.appendChild(galleryItemDiv);

    } 
    
}